// File: ChatAssistantBox.js
import React, { useEffect, useRef, useState } from 'react';
import { X, Maximize2, Paperclip } from 'react-feather';
import axios from 'axios';
import { FaBookBookmark, FaWandMagicSparkles } from 'react-icons/fa6';



// ====== Helpers: minimal rich text renderer (bold + bullets + numbered) ======
function renderBold(str) {
  return str.split(/(\*\*[^*]+\*\*)/g).map((seg, i) => {
    const m = seg.match(/^\*\*([^*]+)\*\*$/);
    if (m) return <strong key={i} style={{ fontWeight: 600 }}>{m[1]}</strong>;
    return <span key={i}>{seg}</span>;
  });
}

// Insert line breaks before inline bullets/numbered markers
function preprocessForLists(text) {
  if (!text) return '';
  let s = String(text);
  s = s.replace(/\s-\s+/g, '\n- ');        // bullets
  s = s.replace(/\s(\d+)\.\s+/g, '\n$1. '); // numbered
  return s;
}

function RichText({ text, color = 'inherit' }) {
  if (!text) return null;

    const wrap = { wordBreak: 'break-word', overflowWrap: 'anywhere' };


  // Build styles with dynamic color; default = inherit (so it follows the bubble)
  const stylesRT = {
     p:  { margin: '0 0 6px 0', lineHeight: 1.35, color, ...wrap },
 ul: { margin: '4px 0 0 16px', padding: 0, color, ...wrap },
 ol: { margin: '4px 0 0 16px', padding: 0, color, ...wrap }
  };

  const prepped = preprocessForLists(text);
  const lines = prepped.split(/\n+/);
  const nodes = [];

  let listType = null; // 'ul' | 'ol' | null
  let listItems = [];

  const flushList = (keyBase) => {
    if (!listType || listItems.length === 0) return;
    if (listType === 'ul') {
      nodes.push(
        <ul key={`ul-${keyBase}`} style={stylesRT.ul}>
          {listItems.map((li, i) => <li key={i} style={wrap}>{renderBold(li)}</li>)}

        </ul>
      );
    } else {
      nodes.push(
        <ol key={`ol-${keyBase}`} style={stylesRT.ol}>
          {listItems.map((li, i) => <li key={i} style={wrap}>{renderBold(li)}</li>)}

        </ol>
      );
    }
    listType = null;
    listItems = [];
  };

  lines.forEach((raw, idx) => {
    const line = raw.trim();
    if (!line) return;

    if (/^-\s+/.test(line)) {
      const content = line.replace(/^-+\s+/, '');
      if (listType && listType !== 'ul') flushList(idx);
      listType = 'ul';
      listItems.push(content);
      return;
    }

    const numMatch = line.match(/^(\d+)\.\s+(.*)$/);
    if (numMatch) {
      const content = numMatch[2];
      if (listType && listType !== 'ol') flushList(idx);
      listType = 'ol';
      listItems.push(content);
      return;
    }

    flushList(idx);
    nodes.push(<p key={`p-${idx}`} style={stylesRT.p}>{renderBold(line)}</p>);
  });

  flushList('end');
  return <>{nodes}</>;
}







const NOT_FOUND_RE = /no\s+user\s+in\s+crm\s+found/i;

const ChatAssistantBox = ({ visible, onClose, from, to, callActive, callEnded, sessionId }) => {
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState('');
   const [selectedFiles, setSelectedFiles] = useState([]);
 const fileInputRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [initialized, setInitialized] = useState(false);
  const [collapsed, setCollapsed] = useState(false);
  const [headerText, setHeaderText] = useState('');    // NEW
  const [hasHeaderData, setHasHeaderData] = useState(false); // NEW
  const messageEndRef = useRef(null);

  const [initialLoading, setInitialLoading] = useState(false); // NEW: first/system call only


  const mobileChatCSS = `
@media (max-width: 600px) {
  .chat-assistant-wrapper {
    right: 0 !important;
    bottom: 0 !important;
    width: 100vw !important;
    height: 90vh !important;
    pointer-events: none;
    z-index: 1500;
  }
  .chat-assistant-wand-btn {
    right: 30px !important;
    top: 0px !important;
    width: 56px !important;
    height: 56px !important;
    min-width: 46px !important;
    min-height: 46px !important;
    z-index: 1600 !important;
    display: flex !important;
    pointer-events: auto !important;
  }
  .chat-assistant-panel {
    width: 100vw !important;
    height: 75vh !important;
    pointer-events: auto !important;
  }
}
`;

  useEffect(() => {
    if (callActive && visible && !initialized && from && to && sessionId) {
      const query = `Tell the details of the item whose phone number is ${from || to}, if found nothing then send Just mentioning - No User In CRM Found.?`;
      sendQuery(query, true); // system (no user bubble)
      setInitialized(true);
    }
  }, [callActive, visible, initialized, from, to, sessionId]);

  useEffect(() => {
    if (messageEndRef.current) {
      messageEndRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [messages, loading]);

const makeAttachmentPreviews = (files) =>
  Array.from(files).map((f) => {
    const url = URL.createObjectURL(f);
    const lower = (f.type || '').toLowerCase();
    const isImg = lower.startsWith('image/');
    const isAud = lower.startsWith('audio/');
    return { name: f.name, url, type: isImg ? 'image' : (isAud ? 'audio' : 'file') };
  });

const clearFileInput = () => {
  setSelectedFiles([]);
  if (fileInputRef.current) fileInputRef.current.value = '';
};




  const maybeSetHeaderFromText = (txt) => {
    if (!txt) return;
    if (!NOT_FOUND_RE.test(String(txt))) {
      setHeaderText(String(txt));
      setHasHeaderData(true);
    }
  };

    // const BASE = 'http://localhost:8000'; //For local
  const BASE = 'https://bot.mergeasy.com'; //For production

   const sendQuery = async (text, isSystem = false) => {
  if (isSystem) setInitialLoading(true); // NEW
  setLoading(true);
  try {
     let res;
     if (!isSystem && selectedFiles.length > 0) {
       // ---- multipart with files ----
       const form = new FormData();
       form.append('text', text || '');
       form.append('session_id', sessionId);
       form.append('to', to);
       form.append('from', from);
       form.append('ai_sense', "ai_chat_bot");

       selectedFiles.forEach(f => form.append('files', f, f.name));
       // add user bubble with previews
       const previews = makeAttachmentPreviews(selectedFiles);
       setMessages(prev => [...prev, { text, sender: 'user', attachments: previews }]);



       res = await axios.post(
       `${BASE}/agent-query`,

        form,
         { headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` } }
       );
       clearFileInput();
     } else {
       // ---- JSON only ----
       if (!isSystem) setMessages(prev => [...prev, { text, sender: 'user' }]);



       res = await axios.post(
        `${BASE}/agent-query`,
         { text, session_id: sessionId,to,from,ai_sense:"ai_chat_bot" },
         { headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${localStorage.getItem('token')}` } }
       );
     }
    const botMsg = res?.data?.response || 'No response';
    const podioRefs = res?.data?.podio_refs || null;
    const responseId = res?.data?.response_id || null;

    setMessages(prev => [
      ...prev,
      {
        text: botMsg,
        sender: 'bot',
        podio_refs: podioRefs,
        response_id: responseId,
        saved: false
      }
    ]);

    // set header from the very first reply (or if header not set yet)
    if (isSystem || !hasHeaderData) {
      maybeSetHeaderFromText(botMsg);
    }
  } catch (err) {
    console.error(err);
    setMessages(prev => [...prev, { text: 'Something went wrong', sender: 'bot' }]);
  } finally {
    if (isSystem) setInitialLoading(false); // NEW
    setLoading(false);
  }
};


  const handleSaveToKnowledgebase = async (responseId, podioRefs, index) => {
    try {
      const res = await axios.post(
        'https://bot.mergeasy.com/podio/index-by-response',
        { response_id: responseId, podio_refs: podioRefs },
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          }
        }
      );
      if (res.status === 200) {
        const newMessages = [...messages];
        newMessages[index].saved = true;
        setMessages(newMessages);
      }
    } catch (err) {
      console.error('Failed to save to KB:', err);
    }
  };

  // choose the best phone we have for seeding on the new tab if needed
const seedPhone = from || to || '';
const openFullScreen = () => {
  const id = encodeURIComponent(sessionId || '');
  const phone = encodeURIComponent(seedPhone);
  const url = `/ai/chat/${id}?phone=${phone}`;
  window.open(url, '_blank', 'noopener,noreferrer');
};


  if (!callActive || !visible) return null;

  return (
    <>
      <style>{mobileChatCSS}</style>
      <div
        className="chat-assistant-wrapper"
        style={{
          position: 'fixed',
          bottom: '20vh',
          right: '11vw',
          zIndex: 1500,
          width: 320,
          pointerEvents: 'none'
        }}
      >
        {/* Magic Wand */}
        <button
          className="chat-assistant-wand-btn"
          onClick={() => setCollapsed(c => !c)}
          title={collapsed ? 'Open Assistant' : 'Collapse Assistant'}
          style={{
            position: 'absolute',
            right: -145,
            width: 60,
            height: 60,
            borderRadius: '50%',
            border: 'none',
            cursor: 'pointer',
            pointerEvents: 'auto',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: 'linear-gradient(135deg, #4144f5ff 0%, #37bcfaff 100%)',
            boxShadow: '0 10px 20px rgba(0,0,0,0.18), inset 0 0 12px rgba(255,255,255,0.22)',
            transition: 'transform 250ms ease, box-shadow 250ms ease, filter 250ms ease',
            transform: collapsed ? 'rotate(-12deg) scale(1.02)' : 'rotate(0deg) scale(1)',
            filter: collapsed ? 'brightness(1.05)' : 'none',
            outline: 'none',
            WebkitTapHighlightColor: 'transparent'
          }}
          onMouseDown={e => (e.currentTarget.style.transform = 'scale(0.96)')}
          onMouseUp={e => (e.currentTarget.style.transform = collapsed ? 'rotate(-12deg) scale(1.02)' : 'rotate(0deg) scale(1)')}
          onMouseLeave={e => (e.currentTarget.style.transform = collapsed ? 'rotate(-12deg) scale(1.02)' : 'rotate(0deg) scale(1)')}
        >
          <FaWandMagicSparkles size={18} color="#fff" />
        </button>

        {/* Panel */}
        <div
          className="chat-assistant-panel"
          style={{
            pointerEvents: collapsed ? 'none' : 'auto',
            width: 400,
            height: 600,
            background: 'white',
            borderRadius: 10,
            boxShadow: '0 0 7px rgba(0,0,0,0.20)',
            display: 'flex',
            flexDirection: 'column',
            transformOrigin: 'top right',
            transform: collapsed ? 'scale(0.1)' : 'scale(1)',
            opacity: collapsed ? 0 : 1,
            transition: 'transform 300ms cubic-bezier(0.22, 1, 0.36, 1), opacity 220ms ease'
          }}
        >
          {/* Header (dynamic) */}
          <div style={{ background: '#f2f2f2', padding: 10 }}>
            {/* <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              {!hasHeaderData ? (
                <strong>✨🤖 AI Assistant</strong>
              ) : (
                <strong style={{ color: '#111827' }}>Conversation</strong>
              )}
          

              <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
  <Maximize2
    title="Open in new tab"
    onClick={openFullScreen}
    style={{ cursor: 'pointer' }}
    size={18}
    color="black"
  />
  {callEnded && (
    <X
      onClick={() => {
        onClose && onClose();
        setMessages([]);
        setInput('');
        setInitialized(false);
        setCollapsed(false);
        setHeaderText('');
        setHasHeaderData(false);
      }}
      style={{ cursor: 'pointer' }}
      size={18}
      color="black"
    />
  )}
</div>
            </div> */}

 <div style={{ padding: 16, borderBottom: '1px solid #e5e7eb', display: 'flex', alignItems: 'center', justifyContent: 'space-between'  }}>

                  {!hasHeaderData ? (
              <h3 style={{ margin: 0, fontSize: 16, fontWeight: 600, color: '#111827' }}>✨🤖 AI Assistant</h3>
              ) : (
              <h3 style={{ margin: 0, fontSize: 16, fontWeight: 600, color: '#111827' }}>Conversation</h3>
              )}
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, color: '#6b7280' }}>
                 <Maximize2
    title="Open in new tab"
    onClick={openFullScreen}
    style={{ cursor: 'pointer' }}
    size={18}
    color="black"
  />
  {callEnded && (
    <X
      onClick={() => {
        onClose && onClose();
        setMessages([]);
        setInput('');
        setInitialized(false);
        setCollapsed(false);
        setHeaderText('');
        setHasHeaderData(false);
      }}
      style={{ cursor: 'pointer' }}
      size={18}
      color="black"
    />
  )}
              </div>
            </div>

            {hasHeaderData && (
              <div
                style={{
                  marginTop: 8,
                  background: 'linear-gradient(180deg, #ffffff 0%, #f9fafb 100%)',
                  borderRadius: 12,
                  padding: 12,
                  border: '1px solid #e5e7eb',
                  position: 'relative',
                  overflow: 'hidden'
                }}
              >
                <div
                  style={{
                    position: 'absolute',
                    left: 0,
                    top: 0,
                    height: '100%',
                    width: 6,
                    background: 'linear-gradient(180deg, #6366f1 0%, #22d3ee 100%)'
                  }}
                />
                <div style={{ marginLeft: 12, maxHeight: 140, overflow: 'auto' }}>
                  <RichText text={headerText} color="#111827"  />
                </div>
              </div>
            )}
          </div>

          {/* Messages */}
          <div style={{ flex: 1, overflowY: 'auto', padding: 10 }}>
            {messages.map((msg, idx) => (
              <div
                key={idx}
                style={{
                  textAlign: msg.sender === 'user' ? 'right' : 'left',
                  marginBottom: 10
                }}
              >
                <div
                  style={{
                    display: 'inline-block',
                    padding: '8px 12px',
                    borderRadius: 15,
                    backgroundColor: msg.sender === 'user' ? '#007bff' : '#e0e0e0',
                    color: msg.sender === 'user' ? 'white' : 'black',
                    maxWidth: '70%',
                    position: 'relative',
                    fontSize: 14,
                    boxShadow: msg.sender === 'user'
                      ? '0 4px 10px rgba(0, 123, 255, 0.25)'
                      : '0 4px 10px rgba(0,0,0,0.08)',
                       wordBreak: 'break-word',
 overflowWrap: 'anywhere',
 minWidth: 0
                  }}
                >
<RichText text={msg.text} />

{msg.attachments && msg.attachments.length > 0 && (
  <div style={{ marginTop: 8 }}>
    {msg.attachments.map((a, i) => {
      if (a.type === 'image') {
        return <img key={i} src={a.url} alt={a.name} style={{ maxWidth: 220, borderRadius: 8, display: 'block', marginTop: 6 }} />;
      } else if (a.type === 'audio') {
        return <audio key={i} controls src={a.url} style={{ display: 'block', marginTop: 6, maxWidth: 240 }} />;
      }
      return <a
  href={a.url}
  target="_blank"
  rel="noreferrer"
  style={{ color: '#fff', textDecoration: 'underline', wordBreak: 'break-word', overflowWrap: 'anywhere' }}
>
  {a.name}
</a>
    })}
  </div>
)}

                </div>

                {msg.sender === 'bot' && msg.podio_refs && msg.response_id && !msg.saved && (
                  <div
                    style={{
                      cursor: 'pointer',
                      fontSize: 12,
                      marginTop: 2,
                      display: 'flex',
                      alignItems: 'center',
                      gap: 4
                    }}
                    title="Add to knowledgebase for future reference"
                    onClick={() => handleSaveToKnowledgebase(msg.response_id, msg.podio_refs, idx)}
                  >
                    <FaBookBookmark size={14} color="#007bff" />
                    <span style={{ color: '#007bff' }}>Save to KB</span>
                  </div>
                )}
              </div>
            ))}
      

            {initialLoading && (
  <div style={{ textAlign: 'left', marginTop: 10, fontStyle: 'italic', color: '#888', fontSize: 14 }}>
    Checking CRM for details related to this number…
  </div>
)}
{!initialLoading && loading && (
  <div style={{ textAlign: 'left', marginTop: 10, fontStyle: 'italic', color: '#888', fontSize: 14 }}>
    Typing...
  </div>
)}

            <div ref={messageEndRef} />
          </div>

          {/* Input */}
          {/* <div style={{ padding: 10, borderTop: '1px solid #ccc' }}>
            <input
              value={input}
              onChange={(e) => setInput(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter' && !loading && input.trim()) {
                  sendQuery(input);
                  setInput('');
                }
              }}
              placeholder={'Type a message...'}
              disabled={loading}
              style={{
                width: '100%',
                padding: 8,
                borderRadius: 25,
                border: '1px solid #ccc',
                fontSize: 14
              }}
            />
          </div> */}

          {/* Input + Attachments */}
<div style={{ padding: 10, borderTop: '1px solid #ccc' }}>
  <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
    <button
      type="button"
      title="Attach files"
      onClick={() => fileInputRef.current?.click()}
      style={{
        width: 36, height: 36, borderRadius: '50%', border: 'none',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        background: 'linear-gradient(135deg,#4144f5 0%, #37bcfa 100%)',
        boxShadow: '0 6px 14px rgba(0,0,0,0.15)', cursor: 'pointer'
      }}
    >
      <Paperclip size={16} color="#fff" />
    </button>
    <input
      value={input}
      onChange={(e) => setInput(e.target.value)}
      onKeyDown={(e) => {
        if (e.key === 'Enter' && !loading && (input.trim() || selectedFiles.length > 0)) {
          sendQuery(input.trim(), false);
          setInput('');
        }
      }}
      placeholder="Type a message…"
      disabled={loading}
      style={{ flex: 1, padding: 8, borderRadius: 25, border: '1px solid #ccc', fontSize: 14 }}
    />
    <input
      ref={fileInputRef}
      type="file"
      multiple
      style={{ display: 'none' }}
      accept="image/*,audio/*"
      onChange={(e) => setSelectedFiles(Array.from(e.target.files || []))}
      // To allow ALL file types, remove the `accept` line above or set: accept="*/*"
    />
  </div>
  {selectedFiles.length > 0 && (
    <div style={{ marginTop: 6, fontSize: 12, color: '#6b7280' }}>
      {selectedFiles.length} file(s) selected
    </div>
  )}
</div>
        </div>
      </div>
    </>
  );
};

export default ChatAssistantBox;







